import { Component } from '@theme/component';

class VintageSzafaAppPromo extends Component {
  #abort;
  #observer;
  #covered = new Set();
  #dismissed = false;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#abort?.abort();
    this.#abort = new AbortController();
    try { this.#dismissed = sessionStorage.getItem('vs-app-promo-dismissed') === '1'; } catch {}
    const rail = this.refs.rail;
    if (!rail) return;
    const update = () => this.#schedule();
    const signal = this.#abort.signal;
    window.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { passive: true, signal });
    document.addEventListener('shopify:section:load', () => this.#observe(), { signal });
    this.#observe();
    this.#schedule();
  }

  #observe() {
    this.#observer?.disconnect();
    this.#covered.clear();
    this.#observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) this.#covered.add(entry.target);
        else this.#covered.delete(entry.target);
      }
      this.#schedule();
    });
    for (const node of document.querySelectorAll('[data-vs-app-story], [data-vs-app-teaser], [data-vs-app-footer]')) {
      this.#observer.observe(node);
    }
  }

  #schedule() {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      if (!this.refs.rail) return;
      const installed = navigator.standalone === true || matchMedia('(display-mode: standalone)').matches;
      this.refs.rail.hidden = this.#dismissed || installed || !matchMedia('(max-width: 749px)').matches || window.scrollY < 650 || this.#covered.size > 0;
    });
  }

  dismiss() {
    this.#dismissed = true;
    try { sessionStorage.setItem('vs-app-promo-dismissed', '1'); } catch {}
    this.#schedule();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
    this.#observer?.disconnect();
    this.#covered.clear();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }
}

if (!customElements.get('vs-app-promo')) customElements.define('vs-app-promo', VintageSzafaAppPromo);
